module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/picture_3-893f469054fff61169f8538ef1178f61.webp";